// extracted by mini-css-extract-plugin
export default {"container":"select_container__QTwfM","title":"select_title__UtkDA","p":"select_p__DusTy","loading":"select_loading__bOcEo","header":"select_header__hlMeH"};